module.exports = __webpack_public_path__ + "media/images/country_flags/ba-b0d5ba57bcd26fc3d0c83cdefe11693f.png";